var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInputBarVoiceRecording(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-input-bar-voice-recording",
    transform: "translate(-442 -301)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5674",
    "data-name": "Rectangle 5674",
    width: 29,
    height: 30,
    transform: "translate(442 301)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6983",
    "data-name": "Group 6983",
    transform: "translate(447.343 303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M17.59,19.208h0a5.132,5.132,0,0,1-5.132-5.132V6.132a5.132,5.132,0,0,1,10.265,0v7.943A5.132,5.132,0,0,1,17.59,19.208Z",
    transform: "translate(-8.257 -1)",
    fill: "none",
    stroke: "#f7114d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M19.666,33.417v1.146A9.333,9.333,0,0,1,1,34.563V33.417",
    transform: "translate(-1 -21.533)",
    fill: "none",
    stroke: "#f7114d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    y2: 4.094,
    transform: "translate(9.333 22.363)",
    fill: "none",
    stroke: "#f7114d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    x1: 6.416,
    transform: "translate(6.125 26.456)",
    fill: "none",
    stroke: "#f7114d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInputBarVoiceRecording);
export default __webpack_public_path__ + "static/media/icon-input-bar-voice-recording.d3f2ff0ab0c3b0b98be97e885704a467.svg";
export { ForwardRef as ReactComponent };